__turbopack_context__.v({
  "isSelected": "styles-module-scss-module__8oCfkq__isSelected",
  "navigation": "styles-module-scss-module__8oCfkq__navigation",
  "navigationLink": "styles-module-scss-module__8oCfkq__navigationLink",
});
